const C = {
  name: "Lock5",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z" fill="currentColor"/>
<path d="M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" fill="currentColor"/>
<path d="M12 1C9.23858 1 7 3.23858 7 6V8H5C3.34315 8 2 9.34315 2 11V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V11C22 9.34315 20.6569 8 19 8H17V6C17 3.23858 14.7614 1 12 1ZM15 8H9V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V8ZM5 10H19C19.5523 10 20 10.4477 20 11V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V11C4 10.4477 4.44772 10 5 10Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Lock5
};
